import { isPlatformBrowser } from "@angular/common";
import {
    inject,
    Injectable,
    PLATFORM_ID,
} from "@angular/core";
import {
    WebSocketProxyService,
    WebSocketProxyServiceV2,
} from "@Front-end/seed/services";

@Injectable({
    // eslint-disable-next-line no-restricted-syntax
    providedIn: "root",
})
export class WebSocketInitService {
    constructor() {
        inject(WebSocketProxyServiceV2);
    }

    private readonly platformId = inject(PLATFORM_ID);
    private readonly wsV1 = inject(WebSocketProxyService);

    public init(): void {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }

        const connect = (): void => this.wsV1.connect();

        if ("requestIdleCallback" in window) {
            requestIdleCallback(connect, { timeout: 3000 });
        } else {
            setTimeout(connect, 0);
        }
    }
}
